import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { KENDO_INPUTS } from '@progress/kendo-angular-inputs';

import { DynamicFilterOptions } from '../report-groups-dynamic-filter.types';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { TranslateModule } from '@ngx-translate/core';
import { translationKeysMap } from 'src/app/services/translate/translate.key-mapper';

@Component({
  selector: 'aos-radiobutton-dynamic-filter',
  imports: [ReactiveFormsModule, KENDO_INPUTS, TranslateModule],
  template: `
    <form
      class="aos-dynamic-filters"
      [formGroup]="form()"
    >
      <div class="aos-dynamic-filters__radiobuttons-container">
        @for (item of itemsTranslated(); track item.value) {
          <label class="aos-dynamic-filters__label">
            <input
              [value]="item.value"
              formControlName="values"
              kendoRadioButton
              type="radio"
            />
            <span>
              {{ item.text | translate }}
            </span>
          </label>
        } @empty {
          {{ noItemsLabel | translate }}
        }
      </div>
    </form>
  `,
  styleUrl: './dynamic-filters.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RadiobuttonDynamicFilterComponent {
  form = input.required<FormGroup>();
  items = input.required<DynamicFilterOptions[]>();

  protected noItemsLabel = TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.FORM.THERE_ARE_NO_ITEMS;

  protected readonly itemsTranslated = computed(() =>
    this.items().map(item => ({ text: translationKeysMap.get(item) || item, value: item }))
  );
}
